import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { MenuItem, Divider, Paper, Popper, MenuList, ClickAwayListener } from "@material-ui/core";
import { PrimaryButton } from "@loanbossinc/component-library";
import moment from "moment";
import { connect } from "react-redux";
import { compose } from "redux";
import { getShareRecords } from "./lenderReportingDashboard.store";
import ShareReportModal from "./shareReportModal";


const RgiApprovedHeaderContainers = styled.div`
    width: calc(1120px - 2em);
    background-color: #F6F2F2;
    height: 114px;
    display: flex;
    justify-content: space-between;
    padding: 1em;
`;

const LeftContainer = styled.div`
    align-self: center;
`;

const RightContainer = styled.div`
    display: flex;
    align-items: flex-end;
    flex-direction: column;
`;

const ApprovedOn = styled.div`
    font-weight: bold;
    color: #000000;
    font-size: 14px;
`;

const ApprovalContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1em;
`;

const ApprovedBy = styled.div`
    font-weight: 500;
    font-size: 14px;
    color: grey;
`;

const ApprovedByEmail = styled.div`
    font-weight: 500;
    font-size: 14px;
    color: #005AA9;
`;

const ShareButton = styled(PrimaryButton)`&& {
    width: 132px !important;
    height: 36px !important;
    background: #005AA9;
    color: #FFFFFF;
    font-size: 14px;
}`;

const EditReportButton = styled(PrimaryButton)`&& {
    width: 132px !important;
    height: 36px !important;
    background: #FFF;
    border:1px solid #005AA9;
    color: #005AA9;
    font-size: 14px;
}`;

const IconContainer = styled.div`
    height: 36px;
    width: 36px;
    color: #00FF00;
    & > button > span > i {
        font-size: 36px;
        color: #50C40A;
    }
`;

const LastSentWrapper = styled.div`
    height: 36px;
`;

const LastSent = styled.div`
    font-family: "Work Sans";
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    color: #A9A9A9;
    text-align: right;
`;

const EditShareButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1em;
`;

const ApprovedSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0.5em;
`;

const VerifiedIcon = styled.div`
    font-size: 36px;
    color: #50c40a;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
`;

const ShareHistoryButton = styled.div`
  && {
    text-transform: none;
    font-size: 16px;
    line-height: 23px;
    font-weight: 500;
    padding-top: 5px;
    font-family: work sans;
    color: #005aa9;
    cursor: pointer;
  }
`;

// NOSONAR
const RgiApprovedHeader = ({ lastSent, setShowEditView, taskDetails, setAsMarkedExternal, setAsMarkedEmail, getShareRecords, shareRecords,
  submitReport, canApprove, userEmail, rgiId, userName, company, expirationDate, contacts, prevPin, externalShare }) => {
  const [openShareModal, setOpenShareModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [shareHistory, setShareHistory] = useState([]);
  const [shareHistorySaved, setShareHistorySaved] = useState(false);
  const taskApprover = taskDetails.approval?.approver;
  const taskApproverCompany = taskDetails.approval?.approverCompany;
  const [displayShareReportScreen, setDisplayShareReportScreen] = useState(false);
  const [displayShareHistoryScreen, setDisplayShareHistoryScreen] = useState(false);

  const loadRecords = () => {
    getShareRecords({ rgiId });
  };

  useEffect(() => {
      loadRecords();
  }, [rgiId]);

  useEffect(() => {
    if(shareRecords) {
      setShareHistory(shareRecords);
    }
  }, [shareRecords]);

  const Options = [
    {
      id: 1,
      name: "Share LoanBoss link",
      onClick: () => {
        setDisplayShareReportScreen(true);
        setOpenShareModal(true);
      }
    },
    {
      id: 2,
      name: "Mark as submitted",
      onClick: submitReport
    }
  ];

  const selectItem = id => {
    if(id === 2) {
      setAsMarkedExternal();
    }
  };

  return (
    <RgiApprovedHeaderContainers>
      {openShareModal && (
        <ShareReportModal
          openShareModal={openShareModal}
          setOpenShareModal={setOpenShareModal}
          taskDetails={taskDetails}
          userEmail={userEmail}
          rgiId={rgiId}
          userName={userName}
          company={company}
          expirationDate={expirationDate}
          contacts={contacts}
          prevPin={prevPin}
          submitReport={submitReport}
          displayShareHistoryScreen={displayShareHistoryScreen}
          displayShareReportScreen={displayShareReportScreen}
          setDisplayShareHistoryScreen={setDisplayShareHistoryScreen}
          setDisplayShareReportScreen={setDisplayShareReportScreen}
          shareHistory={shareHistory}
          setShareHistory={setShareHistory}
          setShareHistorySaved={setShareHistorySaved}
          loadRecords={loadRecords}
          setAsMarkedEmail={setAsMarkedEmail}
        />
      )}
      <LeftContainer>
        <ApprovalContainer>
          <IconContainer>
            <VerifiedIcon className="material-icons-outlined">verified</VerifiedIcon>
          </IconContainer>
          <ApprovedSectionWrapper>
            <div>
              <ApprovedOn>Approved on {moment(taskDetails.approval?.approvalDate).format("MMMM DD, YYYY")}</ApprovedOn>
            </div>
            <div>
              <ApprovedBy>
                Approved by
                {` ${taskApprover?.firstName} ${taskApprover?.lastName}, ${taskApproverCompany?.name}`}
              </ApprovedBy>
              <ApprovedByEmail>{taskApprover?.email}</ApprovedByEmail>
            </div>
          </ApprovedSectionWrapper>
        </ApprovalContainer>
      </LeftContainer>
      <RightContainer>
        <LastSentWrapper>
          {lastSent && <LastSent>
            {externalShare !== false ? "Manually submitted on" : "LoanBoss link shared on"}
            {" "}
            {moment(lastSent).format("MMMM DD, YYYY")}
          </LastSent>}
        </LastSentWrapper>
        <EditShareButtonsWrapper>
          {canApprove && (
            <>
              {((shareHistory && shareHistory?.length !== 0) || shareHistorySaved) && (
                <ShareHistoryButton
                  onClick={() => {
                    if(shareHistorySaved) {
                      loadRecords();
                    }
                    setOpenShareModal(true);
                    setDisplayShareHistoryScreen(true);
                  }}
                >
                  Share History
                </ShareHistoryButton>
              )}
              <EditReportButton
                label={"Edit Report"}
                onClick={() => {
                  setShowEditView(true);
                }}
              />
              <ShareButton
                onClick={() => {
                  setOpen(true);
                }}
                label={"Share"}
              />
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Popper
                  keepMounted
                  placement="bottom-start"
                  style={{ visibility: !open ? "hidden" : "" }}
                  className="one-hundred"
                  open={open}
                  anchorEl={null}
                  transition
                  disablePortal
                >
                  <Paper
                    style={{
                      border: "1px solid #DADCE0",
                      width: 240,
                      position: "absolute",
                      left: ((shareHistory && shareHistory?.length !== 0) || shareHistorySaved) ? 164 : 42,
                      top: 40
                    }}
                  >
                    <MenuList elevation={0} getContentAnchorEl={null} anchorEl={null}>
                      {Options.map((item, idx, row) => [
                        <MenuItem
                          data-item-id={item.id}
                          key={idx}
                          onClick={() => {
                            item.onClick();
                            selectItem(item.id);
                            setOpen(false);
                          }}
                        >
                          <span className="button-menu-calc" style={{ fontSize: "14px", fontFamily: "Work Sans" }}>{item.name}</span>
                        </MenuItem>,
                        idx + 1 !== row.length ? <Divider /> : null
                      ])}
                    </MenuList>
                  </Paper>
                </Popper>
              </ClickAwayListener>
            </>
          )}
        </EditShareButtonsWrapper>
      </RightContainer>
    </RgiApprovedHeaderContainers>
  );
};

const mapStateToProps = ({ lenderReportingDashboard, authentication }) => ({
  ...lenderReportingDashboard,
  authentication
});

export default compose(
  connect(mapStateToProps, {
    getShareRecords
  })
)(RgiApprovedHeader);
